export default __webpack_public_path__ + "static/media/honeymob5.93f61d1f.webp";